import React from "react";

const ToggleSkeleton = () => {
  return (
    <div
      className="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-100 dark:bg-slate-700 animate-pulse"
      aria-hidden="true"
    >
      <div className="inline-block h-4 w-4 rounded-full bg-white/80 shadow translate-x-1" />
    </div>
  );
};

const PermissionsSkeleton = ({ moduleCount = 6, modulesPerColumn = 2 }) => {
  const cards = Array.from({ length: moduleCount });

  // Keep the skeleton structure consistent with the real UI.
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
      {cards.map((_, i) => (
        <div
          key={i}
          className="rounded-md border border-gray-200 dark:border-gray-700 p-3 bg-gradient-to-b from-white to-gray-50 dark:from-slate-800 dark:to-slate-900"
        >
          <div className="flex items-center justify-between mb-2">
            <div className="h-4 w-40 rounded bg-gray-100 dark:bg-slate-700 animate-pulse" />
          </div>

          <div className="space-y-2 max-h-[420px] overflow-auto pr-1">
            {Array.from({ length: 8 }).map((__, j) => (
              <div
                key={j}
                className="group flex items-start gap-3 rounded-md border border-transparent p-2"
              >
                <ToggleSkeleton />

                <div className="flex-1">
                  <div className="h-4 w-56 rounded bg-gray-100 dark:bg-slate-700 animate-pulse" />
                  <div className="h-3 w-64 mt-2 rounded bg-gray-100 dark:bg-slate-700 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PermissionsSkeleton;

